export const CHART_SETTINGS = {
  mobile: {
    height: 270,
    xAxis: {
      fontSize: 10,
      height: 40,
      tickMargin: 20,
    },
  },
  largeScreen: {
    height: 400,
    xAxis: {
      fontSize: 14,
      height: 70,
      tickMargin: 35,
    },
  },
};
